<template>
  <div>
    <h6 class="title is-6">Monthly Late Report</h6>
    <div class="columns">
      <div class="column is-3">
        <div class="control">
          <SelectBranch @triggerselectbranch="selectedBranch" />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-1">
        <div class="control">
          <div class="field">
            <label class="label is-small">Month</label>
            <div class="select is-small">
              <select v-model="monthlylatereport.month" :disabled="branchId == 0">
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="control">
          <div class="field">
            <label class="label is-small">Year</label>
            <div class="select is-small">
              <select v-model="monthlylatereport.year" :disabled="branchId == 0">
                <option value="2018">2018</option>
                <option value="2019">2019</option>
                <option value="2020">2020</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="control">
          <div class="field">
            <label class="label is-small">&nbsp;</label>
            <button :class="buttonDownloadPdf" @click="downloadPdfReport" :disabled="branchId == 0">Download PDF</button>
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="control">
          <div class="field">
            <label class="label is-small">&nbsp;</label>
            <button :class="buttonSendPdf" @click="sendPdfReport" :disabled="branchId == 0">Send PDF</button>&nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import AppButton from '../frontend/appButton'
import AppToast from '../frontend/appToast'
import SelectBranch from '../../components/Branch/SelectBranch'

const appButton = new AppButton()
const appToast = new AppToast()

export default {
  components: {
    SelectBranch
  },
  data: () => ({
    branchId: 0,
    branchName: '',
    monthlylatereport: { month: 1, year: 2019 },
    buttonDownloadPdf: appButton.isLoadingNormal(false),
    buttonSendPdf: appButton.isLoadingNormal(false)
  }),
  methods: {
    selectedBranch(branchInfo) {
      this.branchId = branchInfo.branchId ? branchInfo.branchId : 0
      this.branchName = branchInfo.branchName ? branchInfo.branchName : ''
    },
    downloadPdfReport() {
      this.buttonDownloadPdf = appButton.isLoadingNormal(true)
      axios
        .get(
          `downloadables/monthlylatereport?branchId=${this.branchId}&month=${
            this.monthlylatereport.month
          }&year=${this.monthlylatereport.year}`,
          {
            responseType: 'blob'
          }
        )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `Monthly Late Report ${this.monthlylatereport.month}-${
              this.monthlylatereport.year
            }.pdf`
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.buttonDownloadPdf = appButton.isLoadingNormal(false)
        })
    },
    sendPdfReport() {
      this.buttonSendPdf = appButton.isLoadingNormal(true)
      axios
        .get(
          `downloadables/monthlylatereport?month=${
            this.monthlylatereport.month
          }&year=${this.monthlylatereport.year}&isSendToEmail=${true}`
        )
        .then(response => {
          appToast.success(response.data)
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.buttonSendPdf = appButton.isLoadingNormal(false)
        })
    }
  }
}
</script>
